module.exports = __webpack_public_path__ + "static/media/content_rating_s.f5f8c805.svg";